import { RefObject, useMemo, useRef } from 'react';

import { useCategories, useSubCategories, useTests } from './api/data-hooks';
import { buildMainDataTree } from './data-trees/build-data-tree';
import { useClickOutside } from './helpers/use-click-outside';
import { LoadingSpinner } from './components/LoadingSpinner';
import { SearchResults } from './components/Tabs';

import { DebounceInput } from 'react-debounce-input';
import './styles/webflow/webflow.css';
import './styles/webflow/genica.webflow.css';
import './styles/webflow/normalize.css';
import { ImageUrl } from './constants/image-urls';
import { useSearchStore } from './stores/search';

function App () {
  const {
    data: testsData,
    error: testsError,
    isLoading: isTestsListLoading
  } = useTests();
  
  const {
    data: subCategoriesData,
    isLoading: isSubCategoriesDataLoading,
    error: subCategoriesError
  } = useSubCategories();
  
  const {
    data: mainCategoriesData,
    isLoading: isMainCategoriesDataLoading,
    error: categoriesDataError
  } = useCategories();
  
  const {
    searchQueryInput,
    setSearchQueryInput,
    setCurrentCategoryName,
    setCurrentCategoryId,
    setAlphabetSearchCharacter,
  } = useSearchStore((state) => state);
  
  const onSearch = (event: any) => {
    setSearchQueryInput(event.target.value);
  };
  
  const searchResultsRef: RefObject<any> = useRef();
  
  useClickOutside(searchResultsRef, () => {
    setSearchQueryInput('');
    setCurrentCategoryName('');
    setCurrentCategoryId('');
    setAlphabetSearchCharacter('');
  });
  
  const dataTreeMemo = useMemo(() => {
    if (mainCategoriesData
      && mainCategoriesData.length
      && subCategoriesData
      && subCategoriesData.length
      && testsData
      && testsData.length) {
      return buildMainDataTree({ subCategoriesData, mainCategoriesData, testsData });
    }
    
    return [];
  }, [subCategoriesData, mainCategoriesData, testsData]);
  
  if (isSubCategoriesDataLoading
    || isMainCategoriesDataLoading
    || isTestsListLoading
    || !mainCategoriesData
    || !subCategoriesData
    || !testsData) {
    return <div className={'flex flex-col justify-center h-screen items-center'}>
      <p>Моля изчакайте...</p>
      <LoadingSpinner/>
    </div>;
  }
  
  if (categoriesDataError || subCategoriesError || testsError) {
    return <div>Възникна грешка</div>;
  }
  
  return (
    <div style={{ opacity: 1 }} className="page-wrapper">
      <div className="section prices wf-section">
        <div id="go-top" className="container-medium-616px pricing">
          <h1 data-w-id="f3642925-2448-c74f-584e-701177fe5f71"
              className="title neutral-100 prices-title text-5xl font-bold">Изследвания и цени</h1>
          <p data-w-id="f3642925-2448-c74f-584e-701177fe5f73"
             className="paragraph neutral-100 pricing text-lg my-8">Доверете своето здраве на лаборатория „ГЕНИКА“!</p>
          
          <div className="form-block w-form mt-8">
            <DebounceInput
              value={searchQueryInput}
              type="text"
              className="search-input jetboost-list-search-input-8qyp w-input placeholder:text-lg"
              maxLength={256}
              name="Search"
              data-name="Search"
              minLength={2}
              placeholder="Потърси тест"
              data-w-id="87dc993f-7811-1075-1455-a60909260ebf"
              debounceTimeout={300}
              onChange={onSearch}
              required={true}
            />
          </div>
        </div>
        
        <div className="container-default">
          <div className="pricing-tabs-wrapper">
            <div ref={searchResultsRef} className="pricing-tabs w-tabs">
              <SearchResults
                testData={testsData}
                data={dataTreeMemo}
              />
            </div>
          </div>
        </div>
        
        {/*<BackgroundImage/>*/}
        <div className="bg prices-bg">
          <img
            src={ImageUrl.BG_IMAGE}
            data-w-id="f3642925-2448-c74f-584e-701177fe6045"
            style={{ transform: 'translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);opacity:0' }}
            alt="" className="bg pricing-shape-1"
          />
          <div data-w-id="f3642925-2448-c74f-584e-701177fe6046"
            // @ts-ignore
            // style="-webkit-transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);-moz-transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);-ms-transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);transform:translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0);opacity:0"
               className="bg pricing-shape-2"></div>
        </div>
      </div>
    </div>
  );
}

export default App;
